import { theme } from "../theme";

export const StatsStyles = () => ({
  container: {
    display: 'flex',
    gap: '20px',
    width: '100% !important',
    [theme.breakpoints.down('md')]: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '12px 12px'
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      display: 'grid',
      gridTemplateColumns: 'repeat(1, 1fr)'
    },
  },
  box: {
    minHeight: '50px',
    padding: '15px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.cards.bgCards,
    boxSizing: 'border-box',
    color: theme.palette.primary.black,
    width: '100%',
    borderRadius: '10px',
    border: theme.cards.borderCards,
    position: 'relative',
    overflow: 'hidden',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '4px',
      background: theme.palette.primary.main,
      opacity: 0,
      transition: 'opacity 0.3s ease',
    },
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 12px 40px rgba(0, 0, 0, 0.12)',
      border: theme.cards.borderHoverCards,
      '&::before': {
        opacity: 1,
      },
    },
    [theme.breakpoints.down('md')]: {
      padding: '20px 24px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
    },
  },
  gridCard:{
    display: 'flex',
    alignItems: 'center',
    width: '100% !important',
    gap: '10px',
  },
  icon: {
    fontSize: '2rem',
    [theme.breakpoints.down('md')]: {
      fontSize: '1.5rem',
    },
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '56px',
    height: '56px',
    borderRadius: '12px',
    background: theme.cards.iconBackground,
    flexShrink: 0,
    transition: 'all 0.3s ease',
    [theme.breakpoints.down('md')]: {
      width: '44px',
      height: '44px'
    },
    [theme.breakpoints.down('sm')]: {
      width: '40px',
      height: '40px'
    },
  },
  gridCardText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: '0px',
    width: '100%'
  },
  statsTitle: {
    fontSize: '0.875rem',
    padding: "0px",
    margin: "0px",
    lineHeight: '1rem',
    fontWeight: '500',
    color: theme.palette.secondary.mainGray,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    [theme.breakpoints.down('md')]: {
      fontSize: '0.7rem',
    },
  },
  statsData: {
    fontSize: '1.5rem',
    fontWeight: '700',
    padding: "0px",
    margin: "0px",
    background: theme.palette.primary.black,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    [theme.breakpoints.down('md')]: {
      fontSize: '1.2rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
  },
  buttonSearch: {
    minWidth: '120px',
    height: '36px',
    background: 'transparent',
    color: theme.palette.secondary.black,
    fontSize: '0.875rem',
    fontWeight: '600',
    textTransform: 'none',
    borderRadius: '8px',
    boxShadow: theme.button.boxShadowBtn,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      color: theme.palette.primary.white,
      background: theme.button.bgHoverBtn,
      boxShadow: theme.button.boxShadowBtnHover,
    },
    [theme.breakpoints.down('md')]: {
      minWidth: '100px',
      height: '32px',
      fontSize: '0.75rem'
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '90px',
      fontSize: '0.7rem',
      height: '28px'
    },
  },
  statsDataDescription: {
    fontSize: '10PX',
    fontWeight: '300',
    padding: "0px",
    margin: "0px",
    color: theme.palette.secondary.mainGray,
  }
});
